export const CORRECT_PHONE_HANDLING_TOGGLE = 'DE770255_Correct_Phone_Handling';
